import { DataModel as CoreDataModel } from '#core/views.ts';

export const DataModel = {
  ...CoreDataModel,
  IpsoSolution: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
  IpsoAgentArtificialLift: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_artificial_lift_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
  IpsoFieldWellSurveillanceAgent: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
  IpsoAgentPoc: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_agent_poc_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
} as const;
